export const STATUS = {
    PENDING: "PENDING",
    ACCEPTED: "ACCEPTED",
    NOT_ACCEPTED: "NOT_ACCEPTED",
};

export const CONTEXT_KEY = "aggregatorConsent";
